<template>
  <omk-icon-button
    button-type="outlined-icon-button"
    class="delete-icon-btn"
    @click="$emit('click')"
  >
    <omk-icon outline-variant>delete</omk-icon>
  </omk-icon-button>
</template>

<script>
  export default {
    name: 'DocumentDeleteButton',
  };
</script>

<style scoped>
  .delete-icon-btn {
    flex-shrink: 0;
    --omk-icon-button-regular-size: 36px;
    --omk-outlined-icon-button-icon-color: var(
      --omk-colour-icon-danger-resting,
      #c0362c
    );
    --omk-outlined-icon-button-outline-color: var(
      --omk-colour-border-danger-resting,
      #e6a6a1
    );
    --omk-outlined-icon-button-hover-icon-color: var(
      --omk-colour-icon-danger-hover,
      #8f2820
    );
    --omk-outlined-icon-button-hover-outline-color: var(
      --omk-colour-border-danger-hover,
      #c0362c
    );
    --omk-outlined-icon-button-hover-state-layer-color: var(
      --omk-colour-container-danger-hover,
      #f7d9d6
    );
    --omk-outlined-icon-button-hover-state-layer-opacity: 1;
    --omk-outlined-icon-button-pressed-icon-color: var(
      --omk-colour-icon-danger-press,
      #8f2820
    );
    --omk-outlined-icon-button-pressed-outline-color: var(
      --omk-colour-border-danger-press,
      #c0362c
    );
    --omk-outlined-icon-button-pressed-state-layer-color: var(
      --omk-colour-container-danger-press,
      #eeb4ae
    );
  }
</style>
